export default __webpack_public_path__ + "static/media/border_circle.56c10be0.svg";